// 太陽のリズム：日の出・日の入り・二十四節気（端末内計算）
import { Body, Observer, SearchRiseSet, SearchSunLongitude, SunPosition } from 'astronomy-engine';

// 春分（黄経0°）から15°刻み
export const SEKKI_NAMES = [
  '春分', '清明', '穀雨', '立夏', '小満', '芒種', '夏至', '小暑', '大暑', '立秋', '処暑', '白露',
  '秋分', '寒露', '霜降', '立冬', '小雪', '大雪', '冬至', '小寒', '大寒', '立春', '雨水', '啓蟄',
];

// 九星気学で月が切り替わる「節」（立春・啓蟄・清明…小寒）。黄経 315° から 30° 刻み
export function isKigakuSetsu(index: number): boolean {
  return ((index * 15 + 45) % 30) === 0;
}

export type SekkiEvent = { index: number; name: string; date: Date; isSetsu: boolean };

export type SunInfo = {
  sunrise: Date | null;
  sunset: Date | null;
  current: SekkiEvent;      // 今いる節気（始まった日時つき）
  next: SekkiEvent;         // 次の節気
  daysToNext: number;       // 次の節気まで（暦日。今日なら0）
  startsToday: SekkiEvent | null; // 今日始まる節気
};

const DAY_MS = 86400000;

function startOfDay(d: Date): Date { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
function calendarDaysBetween(a: Date, b: Date): number {
  return Math.round((startOfDay(b).getTime() - startOfDay(a).getTime()) / DAY_MS);
}

function sekkiEvent(index: number, from: Date, limitDays: number): SekkiEvent | null {
  const t = SearchSunLongitude(index * 15, from, limitDays);
  return t ? { index, name: SEKKI_NAMES[index], date: t.date, isSetsu: isKigakuSetsu(index) } : null;
}

export function getSunInfo(now: Date, lat: number, lng: number): SunInfo {
  const obs = new Observer(lat, lng, 0);
  const sod = startOfDay(now);
  const rise = SearchRiseSet(Body.Sun, obs, +1, sod, 1);
  const set = SearchRiseSet(Body.Sun, obs, -1, sod, 1);

  const elon = SunPosition(now).elon;
  const curIdx = Math.floor(elon / 15) % 24;
  const nextIdx = (curIdx + 1) % 24;
  const current = sekkiEvent(curIdx, new Date(now.getTime() - 20 * DAY_MS), 20)!;
  const next = sekkiEvent(nextIdx, now, 20)!;
  const startsToday = calendarDaysBetween(now, current.date) === 0 ? current
    : calendarDaysBetween(now, next.date) === 0 ? next : null;

  return {
    sunrise: rise && calendarDaysBetween(now, rise.date) === 0 ? rise.date : null,
    sunset: set && calendarDaysBetween(now, set.date) === 0 ? set.date : null,
    current, next,
    daysToNext: calendarDaysBetween(now, next.date),
    startsToday,
  };
}

export function hhmm(d: Date | null): string {
  if (!d) return '--:--';
  return `${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}`;
}
